import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import Pagination from "../../Components/layouts/pagination";
import BuyersTable from "./Buyers Management/buyers_table";
import { getStatesByCountry } from "../../Components/Functions/city_country_state";
import { useDispatch, useSelector } from "react-redux";
import { FcInTransit } from "react-icons/fc";
import { BsJournalArrowUp } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../redux/Buyer/buyerFiltersReducer";

const BuyersManagement = () => {
  const user = useSelector((store) => store.login.user);
  const role = useSelector((store) => store.login.user.Role);

  const dispatch = useDispatch();
  const store = useSelector((store) => store.buyerFilters);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [states, setStates] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [favBuyer, setFavBuyer] = useState();
  const [filters, setFilters] = useState(store.filters);
  const [page, setCurrPage] = useState(store.currentPage);
  const [projectData, setProjectData] = useState(null);
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);
  const [leadOwner, setLeadOwner] = useState();

  useEffect(() => {
    if (role === process.env.REACT_APP_ROLE_CLIENT) {
      performRequest(
        "GET",
        `/projectTracking/getProjectTracking?name=${user?.Name}`
      )
        .then((res) => {
          if (res.status === 200) {
            setProjectData(res.data);
          } else {
            Toast("error", "Error while getting data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [role, user?.Name]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(
        "/buyerProfiles/getbuyerProfiles/",
        store.currentPage,
        store.filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.buyerProfileData);
          setTotalPages(Math.ceil(res?.data?.buyerProfileCount / 50));
        } else {
          Toast("error", "Error while getting Buyers!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(
        "/favoriteBuyer/getAllFavoriteBuyer/",
        store.currentPage,
        store.filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setFavBuyer(res?.data?.favoriteBuyers);
        } else {
          Toast("error", "Error while getting Buyers!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage]);
  useEffect(() => {
    getStatesByCountry()
      .then((res) => setStates(res))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);

  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };

  const isAdminUser =
    user?.Role === process.env.REACT_APP_ROLE_SUPERADMIN ||
    user?.Role === process.env.REACT_APP_ROLE_ADMIN ||
    user?.Role === process.env.REACT_APP_ROLE_HR;

  if (loading) {
    return <LoadingPage />;
  }

  const projectDataTrak = projectData?.projectTrackingData;

  const workOrder = projectDataTrak?.[0]?.workOrderUpload;

  return (
    <>
      {!workOrder &&
      !isHandOverCompleted &&
      role == process.env.REACT_APP_ROLE_CLIENT ? (
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xxl d-flex flex-column justify-content-center">
              <div className="empty">
                <p className="empty-title">
                  {!isHandOverCompleted && workOrder
                    ? "Your farm handover is not completed yet."
                    : "Your farm has not been deployed yet."}
                </p>
                <p className="empty-subtitle text-muted">
                  Contact your account manager.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
        <div className="page">
          <div className="page-wrapper">
            <div className="container-xxl">
              <div className="page-header d-print-none">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h2 className="page-title mb-1">
                      <FcInTransit className="fs-2  me-1" /> Buyers Connect
                    </h2>
                    <h4 className="text-muted">
                      {/* <StepRoutes /> */} Connect and sale your produce to
                      this buyers.
                    </h4>
                  </div>
                  <div className="col-md-4 ">
                    <div className="btn-list justify-content-end">
                      {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                      process.env.REACT_APP_ROLE_ADMIN_S === user.Role ||
                      process.env.REACT_APP_ROLE_MARKETING === user.Role ||
                      process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                      process.env.REACT_APP_ROLE_SALESCOORDINATOR ===
                        user.Role ? (
                        <a href={"/buyers-management/new"}>
                          <button className="btn btn-primary">
                            <BsJournalArrowUp className="me-2 fs-2" /> ADD NEW
                            BUYERS
                          </button>
                        </a>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        startdate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        enddate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name:"
                                  value={filters.name}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        name: e.target.value,
                                      })
                                    );
                                  }}
                                  placeholder="search name..."
                                  type="text"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search States:"
                                  value={filters.addressState}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      addressState: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        addressState: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Search Entire India</option>

                                  {states &&
                                    states?.map((state, index) => (
                                      <option key={index} value={state?.name}>
                                        {state?.name}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search States:"
                                  value={filters.addressState}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      addressState: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        addressState: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Search Entire India</option>

                                  {states &&
                                    states?.map((state, index) => (
                                      <option key={index} value={state?.name}>
                                        {state?.name}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search Buyer Type:"
                                  value={filters.buyerType}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      buyerType: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        buyerType: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">All Type</option>
                                  <option value="isExporter">Exporter</option>
                                  <option value="isWholesaler">
                                    Wholesaler
                                  </option>
                                  <option value="isTrader">Trader</option>
                                  <option value="isRetailer">Retailer</option>
                                  <option value="isFoodProcessor">
                                    Food Processor
                                  </option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Generated By:"
                                  value={filters.generatedBy}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      generatedBy: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        generatedBy: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Select all</option>

                                  {leadOwner &&
                                    leadOwner?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.userName}
                                      >
                                        {state?.userName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <label class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    checked={filters.favouritesOnly}
                                    onChange={(e) => {
                                      {
                                        setFilters({
                                          ...filters,
                                          favouritesOnly: e.target.checked,
                                        });
                                        dispatch(
                                          setReduxFilters({
                                            ...filters,
                                            favouritesOnly: e.target.checked,
                                          })
                                        );
                                      }
                                    }}
                                    style={{
                                      textAlign: "center",
                                      height: "20px",
                                      width: "20px",
                                    }}
                                  />
                                  <span class="form-check-label">
                                    My Favorite Buyers
                                  </span>
                                </label>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        dispatch(setCurrentPage(1));
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          name: "",
                                          addressState: "",
                                          buyerType: "",
                                          favouritesOnly: false,
                                          userId: "",
                                          startdate: "",
                                          enddate: "",
                                        });
                                        dispatch(
                                          setReduxFilters({
                                            name: "",
                                            addressState: "",
                                            buyerType: "",
                                            favouritesOnly: false,
                                            userId: "",
                                            startdate: "",
                                            enddate: "",
                                          })
                                        );
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name:"
                                value={filters.name}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  );
                                }}
                                placeholder="search name..."
                                type="text"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search States:"
                                value={filters.addressState}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    addressState: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      addressState: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="">Search Entire India</option>

                                {states &&
                                  states?.map((state, index) => (
                                    <option key={index} value={state?.name}>
                                      {state?.name}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search Buyer Type:"
                                value={filters.buyerType}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    buyerType: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      buyerType: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="">All Type</option>
                                <option value="isExporter">Exporter</option>
                                <option value="isWholesaler">Wholesaler</option>
                                <option value="isTrader">Trader</option>
                                <option value="isRetailer">Retailer</option>
                                <option value="isFoodProcessor">
                                  Food Processor
                                </option>
                              </DynamicFilterSelect>
                            </div>

                            {/* <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Generated By:"
                                value={filters.generatedBy}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    generatedBy: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      generatedBy: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="">Select all</option>

                                {leadOwner &&
                                  leadOwner?.map((state, index) => (
                                    <option key={index} value={state?.userName}>
                                      {state?.userName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div> */}

                            {isAdminUser && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Generated By:"
                                  value={filters.generatedBy}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      generatedBy: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        generatedBy: e.target.value,
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Select all</option>
                                  {leadOwner &&
                                    leadOwner?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.userName}
                                      >
                                        {state?.userName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <label class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  checked={filters.favouritesOnly}
                                  onChange={(e) => {
                                    {
                                      setFilters({
                                        ...filters,
                                        favouritesOnly: e.target.checked,
                                      });
                                      dispatch(
                                        setReduxFilters({
                                          ...filters,
                                          favouritesOnly: e.target.checked,
                                        })
                                      );
                                    }
                                  }}
                                  style={{
                                    textAlign: "center",
                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                                <span class="form-check-label">
                                  My Favorite Buyers
                                </span>
                              </label>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      dispatch(setCurrentPage(1));
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        name: "",
                                        addressState: "",
                                        buyerType: "",
                                        favouritesOnly: false,
                                        userId: "",
                                        startdate: "",
                                        enddate: "",
                                      });
                                      dispatch(
                                        setReduxFilters({
                                          name: "",
                                          addressState: "",
                                          buyerType: "",
                                          favouritesOnly: false,
                                          userId: "",
                                          startdate: "",
                                          enddate: "",
                                        })
                                      );
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-none d-lg-block d-md-block">
                    <CustomViedoCard
                      viedoLink={"https://www.youtube.com/embed/Nn6Ii8pmMAs"}
                      id={"model-viedo"}
                      name={"buyers connect"}
                    ></CustomViedoCard>
                  </div>
                  <div className="card mt-2 border-0">
                    <div className="card-body p-0">
                      <img
                        className="d-none d-sm-block"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && favBuyer && user && (
                      <BuyersTable
                        filters={filters}
                        buyers={data}
                        favBuyer={favBuyer}
                        refresh={refresh}
                        userId={user.UserId}
                        setRefresh={setRefresh}
                      />
                    )}

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length || 0}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                  <div className="card mt-2 border-0">
                    <div className="card-body p-0">
                      <img
                        className="d-block d-sm-none"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/Nn6Ii8pmMAs"}
                  id={"model-viedo2"}
                  name={"buyers connect"}
                ></CustomViedoCard>
              </div>
              <div className="page-body">
                <div className="container-xl"></div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default BuyersManagement;
